import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequestPeerFeedbackMutationVariables = Types.Exact<{
  input: Types.RequestPeerFeedbackInput;
}>;


export type RequestPeerFeedbackMutation = { requestPeerFeedback: { success?: boolean | null } };


export const RequestPeerFeedbackDocument = /*#__PURE__*/ gql`
    mutation requestPeerFeedback($input: RequestPeerFeedbackInput!) {
  requestPeerFeedback(data: $input) {
    success
  }
}
    `;

export function useRequestPeerFeedbackMutation() {
  return Urql.useMutation<RequestPeerFeedbackMutation, RequestPeerFeedbackMutationVariables>(RequestPeerFeedbackDocument);
};